import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  List,
  ListItem,
  ListIcon,
  useColorModeValue,
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

import type { CustomerValidationError } from '../utils/validateCustomer';

interface MissingFieldsModalProps {
  isOpen: boolean;
  onClose: () => void;
  errors: CustomerValidationError[];
  onEditClient: () => void;
}

const MissingFieldsModal = ({
  isOpen,
  onClose,
  errors,
  onEditClient,
}: MissingFieldsModalProps) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const handleEditClient = () => {
    onClose();
    onEditClient();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color={textColor}>Missing Client Information</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={4}>
            The following mandatory fields must be completed before creating or
            editing quotes:
          </Text>
          <List spacing={2}>
            {errors.map((error) => (
              <ListItem key={error.field} color="red.500" fontWeight="500">
                <ListIcon as={WarningIcon} color="red.500" />
                {error.label}
              </ListItem>
            ))}
          </List>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="brand" onClick={handleEditClient}>
            Edit Client
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MissingFieldsModal;
